import { combineReducers } from 'redux';
import { LOCATIONS_FETCHED } from '../types';

const byId = (state = {}, action) => {
  switch (action.type) {
    case LOCATIONS_FETCHED:
      return {
        ...state,
        ...action.payload.entities.locations
      };
    default:
      return state
  }
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case LOCATIONS_FETCHED: {
      return action.payload.result
    }
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });



// WEBPACK FOOTER //
// ./src/reducers/locationsReducer.js